import { useQuery } from '@tanstack/react-query'
import casinoService from '../services/casino.service'

/** Row shape from casino home / visibility APIs (loose for varying backends). */
export type CasinoHomeGameRow = {
  _id?: string
  identifier?: string
  game_images?: string
  game_image?: string
  image_url?: string
  game_name?: string
  game_provider?: string
  [key: string]: unknown
}

/** Normalize list shape from various API wrappers */
export function parseCasinoGameList(res: unknown): CasinoHomeGameRow[] {
  const r = res as { data?: { data?: unknown; sports?: unknown } & Record<string, unknown> }
  const list = r?.data?.data ?? r?.data ?? []
  return Array.isArray(list) ? (list as CasinoHomeGameRow[]) : []
}

const STALE_MS = 120_000
const GC_MS = 600_000

/** Shared cache: /home and PreDashboard both use live + slots → one network round-trip set per session window. */
export function useHomeLiveCasinoGames() {
  return useQuery<CasinoHomeGameRow[]>({
    queryKey: ['casino', 'homeLive'],
    queryFn: async () => parseCasinoGameList(await casinoService.getHomeLiveCasinoGames()),
    staleTime: STALE_MS,
    gcTime: GC_MS,
  })
}

export function useHomeSlotsCasinoGames() {
  return useQuery<CasinoHomeGameRow[]>({
    queryKey: ['casino', 'homeSlots'],
    queryFn: async () => parseCasinoGameList(await casinoService.getHomeSlotsCasinoGames()),
    staleTime: STALE_MS,
    gcTime: GC_MS,
  })
}

export function useHomeRecommendedCasinoGames() {
  return useQuery<CasinoHomeGameRow[]>({
    queryKey: ['casino', 'homeRecommended'],
    queryFn: async () => parseCasinoGameList(await casinoService.getRecommendedCasinoGames()),
    staleTime: STALE_MS,
    gcTime: GC_MS,
  })
}
